import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vuetify from "vuetify";
Vue.use(VeeValidate);
Vue.use(Vuetify, {
  iconfont: "md"
});
// import VueEcho from "vue-echo-laravel";

// var token = JSON.parse(localStorage.getItem("token"));
// Vue.use(VueEcho, {
//   broadcaster: "socket.io",
//   host: "http://192.168.1.4:6001",
//   port: 6001,
//   auth: {
//     headers: { Authorization: `Bearer ${token}` }
//   },
//   authEndpoint: "http://192.168.1.4:8000/api/broadcasting/auth"
// });
/** start map */
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LPolyline,
  LCircleMarker,
  LControlLayers,
  LControlAttribution,
  LPopup
} from "vue2-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-polygon", LPolygon);
Vue.component("l-polygon", LPolygon);
Vue.component("l-polyline", LPolyline);
Vue.component("l-circle-marker", LCircleMarker);
Vue.component("l-control-layers", LControlLayers);
Vue.component("l-control-attribution", LControlAttribution);
Vue.component("l-popup", LPopup);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

/** end map */
// start print page

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "@/assets/styles/print2.css"
  ]
};
Vue.use(VueHtmlToPaper, options);
// end print page

// Import VueScheduler
import VueScheduler from "v-calendar-scheduler";
// Import styles
import "v-calendar-scheduler/lib/main.css";
Vue.use(VueScheduler, {
  locale: "en",
  minDate: null,
  maxDate: null,
  labels: {
    today: "اليوم",
    back: "رجوع",
    next: "التالي",
    month: "شهر",
    week: "اسبوع",
    day: "يوم",
    all_day: "كل الايام"
  },
  timeRange: [1, 24],
  availableViews: ["month", "week", "day"],
  initialDate: new Date(),
  initialView: "month",
  use12: true,
  showTimeMarker: true,
  showTodayButton: true,
  eventDisplay: null
});

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDybypvX95q3RDjP1YCIBrYODez11xJoJw",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

import VueToastr2 from "vue-toastr-2";
import "vue-toastr-2/dist/vue-toastr-2.min.css";

window.toastr = require("toastr");
Vue.use(VueToastr2);

import { Sketch } from "vue-color";
Vue.component("material-picker", Sketch);

import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
